export default {
  clients: '/mrx-gateway/mrxassistmemberservice/admin/api/clients',
  updateClient: clientName => `/mrx-gateway/mrxassistmemberservice/admin/api/client/${clientName}`,
  addClient: clientName => `/mrx-gateway/mrxassistmemberservice/admin/api/client/${clientName}`,

  databases: '/mrx-gateway/mrxassistmemberservice/admin/api/clientdatabases',
  updateDatabase: clientDatabaseId => `/mrx-gateway/mrxassistmemberservice/admin/api/clientdatabase/${clientDatabaseId}`,
  addDatabase: '/mrx-gateway/mrxassistmemberservice/admin/api/clientdatabase'
}
